import styled from 'styled-components';
import { StyledPaymentPageCard } from './PaymentPage.styled';

export const StyledSpecialCard = styled(StyledPaymentPageCard)`
    .payment-item {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: start;
        padding: 11px 0;
        border-bottom: 1px solid #F3F1FF;
        &:last-of-type {
          margin-bottom: 11px;
        }

        .checkbox-wrapper {
            display: flex;
            align-items: flex-start;
            gap: 32px;
            text-align: start;
        }

        .type {
            margin-bottom: 5px;
        }
    }

    .icon-wrap {
        margin-top: 4px;
    }

    @media screen and (max-width: 768px) {
        .payment-item {
            font-size: 14px;
        }
    }
`
